import { render, staticRenderFns } from "./CompanyNewsletter.vue?vue&type=template&id=1b70b0d4"
import script from "./CompanyNewsletter.vue?vue&type=script&lang=ts"
export * from "./CompanyNewsletter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports